import React, { useEffect, useState } from "react";
import { useParams, useLocation, useHistory } from "react-router-dom";
import { Col, Row, Spinner, Tabs, Tab } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import API from "../../Utility";
import Moment from "react-moment";
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import EditWorkflowTabView from './EditWorkflowTabView';

export default function WorkflowEditView({ children, ...routeProps }) {
  let { project, workflowId } = useParams();
  let history = useHistory();
  const location = useLocation();
  let stateWorkflow = location && location.state ? location.state.workflow : {};
  let { action } = routeProps;
  if (!action) {
    action = 'update';
  }
  const [workflowName, setWorkflowName] = useState();

  const [workflow, setWorkflow] = useState(stateWorkflow);
  const [isLoading, setIsLoading] = useState(false);
  const [items, setItems] = useState([]);

  async function getWorkflowData(query) {
    try {
      setIsLoading(true);
      let apiWorkflow = await API.get({
        url: query.url,
      });
      setIsLoading(false);
      return apiWorkflow;
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    async function initializeData() {
      let apiWorkflow = await getWorkflowData({
        url: `/admin/${project}/workflows/${workflowId}`,
      });

      setWorkflow(apiWorkflow);
      setWorkflowName(apiWorkflow?.name);
      setItems(apiWorkflow?.milestones);
    }
    if (action && action === "update" && !workflow?._id) {
      initializeData();
    } else {
      setWorkflowName(workflow.name);
      setItems(workflow?.milestones);
    }
  }, []);

  const loading = () => {
    return !workflow?._id && isLoading ? (
      <div>
        <Spinner animation="border" />
      </div>
    ) : (
      <div>
        <span>Workflow not found</span>
      </div>
    );
  };

  const onMilestonesChange = (milestones) => {
    setItems(milestones);
  };

  useEffect(() => {
    onMilestonesChange(items);
  }, [items]);

  if (action && action === 'update' && !workflow?._id) {
    return (
      <React.Fragment>
        <div style={{ display: 'flex', flexDirection: 'row', width: '100%', textAlign: 'center', justifyContent: 'center' }}>
          {loading()}
        </div>
      </React.Fragment>
    );
  }

  return (
    <div className="workflow-view">
      <div>
        <Row>
          <Col>
            <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
              <div style={{ display: 'flex', flexDirection: 'row', flex: 2, justifyContent: 'space-between', alignItems: 'baseline', marginRight: '106px' }}>
                <div style={{ display: 'flex', flexDirection: 'row', fontSize: '30px', alignItems: 'center' }}>
                  <LinkContainer to={`/workflows/${project}`}>
                    <div className='clickable'><b>Workflows</b></div>
                  </LinkContainer>
                  <div style={{ padding: '0 10px' }}>
                    <ArrowForwardIosIcon style={{ fontSize: '25px' }} />
                  </div>
                  <LinkContainer to={`/workflows/${project}/${workflowId}`}>
                    <div className="clickable"><b>{workflowName}</b></div>
                  </LinkContainer>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row', flexShrink: 0 }}>Date Created: <div style={{ marginLeft: '10px' }}><Moment format="DD MMM 'YY">{workflow.created}</Moment></div></div>
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', flex: 1 }}></div>
            </div>
            <br></br>
          </Col>
        </Row>
      </div>
      {workflow && (
        <EditWorkflowTabView workflow={workflow} action={action} />
      )}
    </div >
  );
}